import * as t from "react";
import { c as o } from "../createReactComponent-58f9bea8.mjs";
import { c as e, r } from "../button-7600b6ca.mjs";
import { b as l, a as B, B as f } from "../button-7600b6ca.mjs";
import "../property-9daa16cd.mjs";
import "../query-d94c86d2.mjs";
import "../base-e16d29d8.mjs";
import "../class-map-2994e95e.mjs";
const c = o({ tagName: "ex-button", elementClass: e, react: t, events: { onClick: "click", onContextMenu: "contextmenu" }, displayName: "ExButton", registerWebComponent: r });
export {
  l as ButtonFlavor,
  B as ButtonSize,
  f as ButtonType,
  c as ExButton,
  r as register
};
